import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useEventCallback } from 'usehooks-ts';

import {
  Settings,
  SettingsSkeleton,
} from '@/features/user/components/settings';
import { MainLayout } from '@/shared/components/mainLayout';
import { PageHeader } from '@/shared/components/pageHeader';

export const Route = createFileRoute(
  '/_protected/_app/_mainLayout/me/settings',
)({
  pendingComponent: PendingComponent,
  component: RouteComponent,
});

function PendingComponent() {
  const navigate = useNavigate();

  const handleGoBack = useEventCallback(() => {
    void navigate({ to: '/me' });
  });

  return (
    <MainLayout.Root>
      <PageHeader.Root className="border-warm-600 bg-cold-950/80 sticky top-0 z-10 border-b md:border-b-0 md:bg-transparent">
        <PageHeader.BackButton onClick={handleGoBack} />
      </PageHeader.Root>
      <MainLayout.Content className="w-full px-5 pt-6">
        <SettingsSkeleton />
      </MainLayout.Content>
    </MainLayout.Root>
  );
}

function RouteComponent() {
  const navigate = useNavigate();

  const handleGoBack = useEventCallback(() => {
    void navigate({ to: '/me' });
  });

  return (
    <MainLayout.Root>
      <PageHeader.Root className="border-warm-600 bg-cold-950/80 sticky top-0 z-10 border-b md:border-b-0 md:bg-transparent">
        <PageHeader.BackButton onClick={handleGoBack} />
      </PageHeader.Root>
      <MainLayout.Content className="w-full px-5 pt-6">
        <Settings />
      </MainLayout.Content>
    </MainLayout.Root>
  );
}
